<section>
    <div class="container-fluid banner-img">
        <img class="bottomLogo" src="assets/images/white-logo.svg" alt="">
        <div class="container-fluid banner-img d-flex justify-content-center align-items-center">
            <div class="row py-5">
                <div class="col-lg-12 col-md-12 col-sm-12 wow bounceInUp">
                    <div class="card login-card">
                        <div class="card-header login-header">
                            <img [src]="message.image" class="mb-3"><br>
                            <span class="font-semi-bold">{{message.heading}}</span><br>
                            <p class="font-regular mb-0">{{message.subHeading}}</p>
                        </div>
                        <div class="card-body pt-0">
                            <form class="form" autocomplete="off">
                                <div class="form-group mt-3">
                                    <button type="submit" class="form-control submit-btn theme-button" id="btnLogin"
                                        (click)="loginPage()">
                                        <span>{{message.button}}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>